/// <amd-module name="Artifacts/Maven/helpers/MavenInstallTextHelper" />
import * as MavenRes from "Artifacts/Maven/Resources";
import * as StringUtils from "VSS/Core/Util/String";

export function getMavenPackageInstallText(packageName: string, version: string): string {
  const packageNameParts = packageName ? packageName.split(":") : "";

  if (packageNameParts.length === 2) {
    return renderMavenPackageInstallText(packageNameParts[0], packageNameParts[1], version);
  }

  return MavenRes.MavenOverview_InvalidPackageError;
}
export function getGradlePackageInstallText(packageName: string, version: string): string {
  const packageNameParts = packageName ? packageName.split(":") : "";

  if (packageNameParts.length === 2) {
    return renderGradlePackageInstallText(packageNameParts[0], packageNameParts[1], version);
  }

  return MavenRes.MavenOverview_InvalidPackageError;
}

export function renderGradlePackageInstallText(
  groupId: string,
  artifactId: string,
  version: string,
): string {
  return StringUtils.format(
    "compile(group: '{0}', name: '{1}', version: '{2}')",
    groupId,
    artifactId,
    version,
  );
}

export function renderMavenPackageInstallText(
  groupId: string,
  artifactId: string,
  version: string,
): string {
  // using » to indicate where the indentations will be
  const snippet = `<dependency>
            »<groupId>${groupId}</groupId>
            »<artifactId>${artifactId}</artifactId>
            »<version>${version}</version>
            </dependency>`;

  return snippet.replace(/  +/g, "").replace(/»/g, "  ");
}
